export default __webpack_public_path__ + "static/media/70th_Boule.d9195c73.svg";